import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Styles/Blog.css';
import { startCoinFlip } from '../components/CoinFlipTransition';
import ppEditText from '../assets/images/pp-edit-text.png';
import ppEditFlower from '../assets/images/pp-edit-flower.png';

const BlogNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <nav className="blog-navbar">
      <div className="blog-navbar-container">
        {/* Keep the original brand artwork prominent and crisp. */}
        <Link to="/blog" className="blog-navbar-brand blog-navbar-brand-logo">
          <span className="pp-edit-logo-stage">
            <img src={ppEditText} alt="The PP Edit" className="pp-edit-logo-text" />
            <img src={ppEditFlower} alt="" aria-hidden="true" className="pp-edit-logo-flower" />
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="blog-navbar-links">
          <Link to="/blog" aria-current={pathname.startsWith('/blog') ? 'page' : undefined} className={`nav-link${pathname.startsWith('/blog') ? ' active' : ''}`}>Stories</Link>
          <Link to="/podcast" aria-current={pathname === '/podcast' ? 'page' : undefined} className={`nav-link${pathname === '/podcast' ? ' active' : ''}`}>Podcast</Link>
          <Link to="/know-me" className="nav-link">About Pooja</Link>
          <Link
            to="/"
            className="nav-link nav-link-studio"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
              startCoinFlip();
            }}
          >
            Studio
          </Link>
          <Link to="/work-with-me" className="nav-link nav-link-cta">Work With Me</Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="blog-navbar-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="blog-mobile-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="blog-navbar-mobile" id="blog-mobile-menu">
          <Link to="/blog" className="nav-link-mobile" onClick={() => setMenuOpen(false)}>Stories</Link>
          <Link to="/podcast" className="nav-link-mobile" onClick={() => setMenuOpen(false)}>Podcast</Link>
          <Link to="/know-me" className="nav-link-mobile" onClick={() => setMenuOpen(false)}>About Pooja</Link>
          <Link
            to="/"
            className="nav-link-mobile"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
              startCoinFlip();
            }}
          >
            Studio
          </Link>
          <Link to="/work-with-me" className="nav-link-mobile" onClick={() => setMenuOpen(false)}>
            Work With Me
          </Link>
        </div>
      )}
    </nav>
  );
};

export default BlogNavbar;
